import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

interface FAQ {
  id: string;
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
  const [openFAQ, setOpenFAQ] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="space-y-12">
      <div className="mb-12">
        <h2 className="text-4xl font-black text-[#0C2C39] mb-4 tracking-tighter font-roboto">Query <span className="text-teal-700 italic">Protocols</span></h2>
        <p className="text-[#0C2C39]/50 text-lg font-medium italic">
          Standardized answers to operational inquiries.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {faqs.map((faq) => (
          <div
            key={faq.id}
            className={`neubrutal-card bg-white transition-all duration-300 overflow-hidden ${openFAQ === faq.id ? 'shadow-[2px_2px_0px_0px_#0C2C39]' : ''
              }`}
          >
            <button
              onClick={() => toggleFAQ(faq.id)}
              className="w-full px-8 py-6 text-left flex items-start justify-between hover:bg-[#0C2C39]/5 transition-colors group"
            >
              <span className="font-black text-[#0C2C39] text-base uppercase tracking-tight pr-6 leading-tight">
                {faq.question}
              </span>
              <div className={`mt-1 w-8 h-8 rounded-lg border-2 border-[#0C2C39]/10 flex items-center justify-center transition-all ${openFAQ === faq.id ? 'bg-[#0C2C39] text-white border-[#0C2C39]' : 'text-[#0C2C39]/30 group-hover:text-[#0C2C39] group-hover:border-[#0C2C39]'
                }`}>
                <Icon
                  name="ChevronDown"
                  size={16}
                  className={`transition-transform duration-300 ${openFAQ === faq.id ? 'rotate-180' : ''
                    }`}
                />
              </div>
            </button>

            {openFAQ === faq.id && (
              <div className="px-8 pb-8 animate-in slide-in-from-top-2 duration-300">
                <div className="pt-6 border-t-2 border-[#0C2C39]/5 text-[#0C2C39]/60 leading-relaxed font-medium text-sm">
                  {faq.answer}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="neubrutal-card bg-[#FFF9EB] p-8 border-dashed border-[#0C2C39]/30">
        <div className="flex items-center gap-6">
          <div className="w-14 h-14 bg-[#0C2C39] text-white rounded-2xl flex items-center justify-center shadow-[4px_4px_0px_0px_rgba(13,148,136,0.3)]">
            <Icon name="HelpCircle" size={28} />
          </div>
          <div>
            <h4 className="text-sm font-black text-[#0C2C39] uppercase tracking-widest mb-1">Still Offline?</h4>
            <p className="text-xs text-[#0C2C39]/50 font-bold uppercase tracking-tight">
              Dispatch a direct inquiry for custom specifications.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;